import { useEffect, useState } from 'react';
import { RuleDefinitionDetail } from './RuleDefinitionDetail';
import { SideListHeader } from '../components/ListHeader';
import { LoadingWrapper } from '../components/LoadingWrapper';
import { Error, Table } from '@app/shared';
import { ComponentErrorBoundary } from '@app/utilities';
import { useCategories, useSchema } from '@app/sdk';
import { useGlobalContext } from '../../../GlobalContextProvider';
import { ColDef } from 'ag-grid-community';
import { MasterDetailLayout } from '../components/MasterDetailLayout';
import { Segment } from 'semantic-ui-react';

export function RuleDefinitions() {
  const [categoryId, setCategoryId] = useState(undefined as any);
  const { isLoading: isLoadingSchema, error: errorSchema, data: schema } = useSchema({ categoryId });
  const { isLoading: isLoadingCategories, error: errorCategories, data: categories } = useCategories();
  const { tenantId } = useGlobalContext();
  useEffect(() => {
    setCategoryId(undefined);
  }, [tenantId]);

  const columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'name', headerName: 'Name' },
    { field: 'description', headerName: 'Description' },
  ];

  const master = (
    <Segment style={{ height: '100%' }}>
      <SideListHeader>Categories</SideListHeader>
      <LoadingWrapper loading={isLoadingCategories}>
        {errorCategories && <Error error={errorCategories} />}
        {categories && (
          <div className={'basic'} style={{ height: 'calc(100% - 70px)' }}>
            <Table items={categories} onSelectItem={(category) => setCategoryId(category.id)} columnDefs={columnDefs} />
          </div>
        )}
      </LoadingWrapper>
    </Segment>
  );

  const detail = (
    <Segment>
      {!schema && !isLoadingSchema && <section>Please select a category</section>}
      <LoadingWrapper loading={isLoadingSchema}>
        {errorSchema && <Error error={errorSchema} />}
        {schema && <RuleDefinitionDetail schema={schema} />}
      </LoadingWrapper>
    </Segment>
  );

  return (
    <ComponentErrorBoundary>
      <MasterDetailLayout master={master} detail={detail} />
    </ComponentErrorBoundary>
  );
}
